import JsonLd from '@/components/feature/JsonLd';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotVideos from './components/HotVideos';
import CreatorShowcase from './components/CreatorShowcase';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '香蕉视频',
  url: 'https://www.bananavideo.cn',
  description: '香蕉视频是专为内容创作者打造的短视频分享平台，提供海量原创视频内容、轻松上传发布、智能推荐算法。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.bananavideo.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '香蕉视频',
  url: 'https://www.bananavideo.cn',
  logo: 'https://www.bananavideo.cn/logo.png',
  description: '短视频创作与分享平台',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '北京',
    addressRegion: '北京市',
    addressCountry: 'CN',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer support',
    telephone: '+86-400-888-8888',
    email: 'support@bananavideo.cn',
  },
  sameAs: [
    'https://weibo.com/bananavideo',
    'https://www.zhihu.com/org/bananavideo',
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <JsonLd data={websiteJsonLd} />
      <JsonLd data={orgJsonLd} />

      <header>
        <Navbar />
      </header>

      <main>
        <article>
          <HeroSection />
          <CategoryGrid />
          <HotVideos />
          <CreatorShowcase />
          <FAQSection />
          <CTASection />
        </article>
      </main>

      <Footer />
    </>
  );
}